/**
 * The agent sidebar's menu, declared once.
 *
 * Demopage.js rendered these seven destinations twice, in a desktop block and
 * a mobile block about 250 lines apart, and pages/chat/AgentSidebar.js holds
 * two more copies of the same seven. Four copies of one menu is not a style
 * question: they had already drifted. The last entry reads "Cloud Pricing"
 * with a tooltip explaining that local HART OS and Nunba are freemium in the
 * two Demopage blocks, and plain "Pricing" with no tooltip in both
 * AgentSidebar blocks, because the wording was changed on what was on screen
 * and AgentSidebar is imported by nothing, so nobody saw it.
 *
 * The routes drifted across repos rather than within this one. Nunba's copy of
 * AgentSidebar, which IS rendered there, still points at /AboutHevolve and
 * /Plan. Both resolve in that app, so nothing is broken; they are the legacy
 * spellings, and /AboutHevolve canonicals to /about, so that sidebar points at
 * the alias of the page rather than the page.
 *
 * It lives in its own module rather than at the top of Demopage.js so it can
 * be tested. Demopage cannot be imported under jest -- it builds a worker with
 * new URL(..., import.meta.url), which jest's transform cannot parse -- so
 * anything declared inside it is reachable only through the browser-level
 * checks. A list of destinations is exactly the thing worth asserting against
 * the router, because a destination that does not exist looks completely
 * normal until someone clicks it. That has shipped twice: <Link to="/About">
 * matched no route because React Router is case-sensitive, and /login was
 * linked on a site with no /login among its 103 routes.
 *
 * Only the data is shared. Each block keeps its own class names, because the
 * mobile one scales its type across five breakpoints and the desktop one does
 * not.
 */
const SIDEBAR_LINKS = [
  { to: '/social', label: '🌐 Social' },
  { to: '/social/kids', label: '🧒 Kids Learning' },
  { to: '/admin', label: '⚙️ Admin' },
  { to: '/about', label: 'About Hevolve' },
  { to: '/agents', label: 'Agents' },
  { to: '/aboutus', label: 'About Us' },
  {
    to: '/pricing',
    label: 'Cloud Pricing',
    title:
      'Cloud-only inference pricing. Local HART OS and Nunba are freemium, self-funding via the auto-managed Spark economy.',
  },
];

export default SIDEBAR_LINKS;
